import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountStatements = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#c9e47b",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "AccountStatements",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 16660",
				d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 3",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "Group 5",
						children: [/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16661",
							x: 3.70312,
							y: 5.80945,
							width: 5.55469,
							height: 1,
							rx: .5,
							fill: "currentColor"
						}), /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16662",
							x: 10.7969,
							y: 5.55945,
							width: 1.5,
							height: 1.5,
							rx: .75,
							fill: "currentColor"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group 6",
						children: [/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16663",
							x: 3.70312,
							y: 8.80945,
							width: 5.55469,
							height: 1,
							rx: .5,
							fill: "currentColor"
						}), /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16664",
							x: 10.7969,
							y: 8.55945,
							width: 1.5,
							height: 1.5,
							rx: .75,
							fill: "currentColor"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group 7",
						children: [/* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16665",
							x: 3.70312,
							y: 11.8094,
							width: 5.55469,
							height: 1,
							rx: .5,
							fill: "currentColor"
						}), /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle 16666",
							x: 10.7969,
							y: 11.5594,
							width: 1.5,
							height: 1.5,
							rx: .75,
							fill: "currentColor"
						})]
					})
				]
			})]
		})
	})
});
export default SvgAccountStatements;
